// Season switcher factorisé
// Gère l'affichage d'une seule saison à la fois + toggle placeholders
// Expose deux fonctions: initSeasonSwitcher et updateSeasonTitleFrom

export function updateSeasonTitleFrom(select){
  try {
    const span = document.getElementById('currentSeasonTitle');
    if(!span) return;
    if(select) { span.textContent = select.value; return; }
    const visible = document.querySelector('.season-block, .season-block-off');
    if(visible && visible.dataset.season) span.textContent = visible.dataset.season;
  } catch(e){ /* noop */ }
}

export function initSeasonSwitcher(){
  if(window.__seasonSwitcherInit) return; // évite double init
  window.__seasonSwitcherInit = true;
  try {
    // Gérer les deux variantes: seasonSelect pour interclubs, seasonSelectOff pour compétitions
    const seasonSelect = document.getElementById('seasonSelect') || document.getElementById('seasonSelectOff');
    const qs = (p)=> new URLSearchParams(location.search).get(p);
    const wanted = qs('season');
    if(seasonSelect && wanted && [...seasonSelect.options].some(o=>o.value===wanted)) seasonSelect.value = wanted;

    const applySeason = () => {
      if(seasonSelect){
        const val = seasonSelect.value;
        // Gérer les deux variantes: season-block pour interclubs, season-block-off pour compétitions
        document.querySelectorAll('.season-block, .season-block-off').forEach(b => { 
          b.style.display = (b.dataset.season === val) ? 'block' : 'none'; 
        });
      }
      updateSeasonTitleFrom(seasonSelect);
    };

    // Fallback si saison vide: on bascule sur la première saison contenant au moins une carte
    const ensureNotEmpty = () => {
      if(!seasonSelect) return;
      const current = seasonSelect.value;
      const currentBlock = document.querySelector('.season-block[data-season="'+current+'"], .season-block-off[data-season="'+current+'"]');
      if(currentBlock && currentBlock.querySelector('.card')) return; // il y a du contenu
      const candidate = [...document.querySelectorAll('.season-block, .season-block-off')].find(b => b.querySelector('.card'));
      if(candidate){
        const season = candidate.dataset.season;
        if(season && season !== current){
          seasonSelect.value = season;
          applySeason();
        }
      }
    };

    // Synchronisation explicite du titre avec le paramètre demandé
    const syncTitleWithParam = () => {
      try {
        const span = document.getElementById('currentSeasonTitle');
        if(!span) return;
        if(seasonSelect){
          const selVal = seasonSelect.value;
          // Ne privilégie 'wanted' que si la sélection actuelle correspond encore à ce paramètre
          if(wanted && selVal === wanted){
            if(span.textContent !== wanted) span.textContent = wanted;
          } else {
            if(span.textContent !== selVal) span.textContent = selVal;
          }
        } else {
          // fallback sans select
          const visible = document.querySelector('.season-block[style*="display: block"], .season-block:not([style]), .season-block-off[style*="display: block"], .season-block-off:not([style])');
          if(visible && visible.dataset.season && span.textContent !== visible.dataset.season){
            span.textContent = visible.dataset.season;
          }
        }
      } catch(e){ /* noop */ }
    };

    if(seasonSelect){
      seasonSelect.addEventListener('change', () => {
        try {
          const url = new URL(location.href);
          url.searchParams.set('season', seasonSelect.value);
          history.replaceState({}, '', url);
        } catch(e){}
        applySeason();
        ensureNotEmpty();
        syncTitleWithParam();
      });
    }

    applySeason();
    ensureNotEmpty();
    syncTitleWithParam();
    // Fallbacks différés pour cas de rendu tardif ou CSS transitions
    requestAnimationFrame(syncTitleWithParam);
    setTimeout(syncTitleWithParam, 60);
  } catch(e){ /* noop */ }
}

// Auto-init si déjà prêt
if(document.readyState !== 'loading') { initSeasonSwitcher(); updateSeasonTitleFrom(); }
else document.addEventListener('DOMContentLoaded', function(){ initSeasonSwitcher(); updateSeasonTitleFrom(); });
